import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Redirect, useHistory, useLocation } from 'react-router';


interface IProductCheckContext {
    isSearching: boolean
    isSearchDone: boolean
    productInfo?: IProductInfo
    productSearch: string

    updateSearch: (newSearch: string) => void
    doSearch: () => void
}

interface IProductInfo {
    sku: string
    brandCode: string
    isQrMandatory: boolean
    isQrPresent: boolean
    unlimited: boolean
    warrantyExtensionMonths: number
}

export let productInfoContext = React.createContext({} as IProductCheckContext);

let { Provider } = productInfoContext;

let ProductCheckProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let history = useHistory();
    let location = useLocation();

    let [isSearching, setSearching] = useState(false);
    let [isSearchDone, setSearchDone] = useState(false);
    let [productInfo, setProductInfo] = useState<IProductInfo>();

    let [productSearch, setProductSearch] = useState('');


    useEffect(() => {
        if (location.state)
            processState(location.state);
    }, [location.state])

    if (!location.state)
        return <Redirect to={{ pathname: location.pathname, state: { productSearch } }} />


    let processState = (state: any) => {
        if (state.productSearch) {
            setProductSearch(state.productSearch)
        }

        searchProduct(state.productSearch);
    }

    let doSearch = () => {
        if (productSearch === '')
            return;

        history.push(location.pathname, { productSearch });
    }

    let searchProduct = async (search: string) => {
        if (search === '')
            return;

        try {
            setSearching(true);
            setSearchDone(false);

            let res = await axios.get('/api/Product/SearchProduct', { params: { searchTerm: search } });
            if (res.data)
                setProductInfo(res.data);

            setSearchDone(true);

        } catch (err) { }
        finally {
            setSearching(false);
        }
    }

    let updateSearch = (newSearch: string) => {
        setProductSearch(newSearch);
    }


    return (
        <Provider
            value={{
                isSearching,
                isSearchDone,
                productInfo,
                productSearch,

                updateSearch,
                doSearch
            }}
        >
            {children}
        </Provider>
    )
}

export default ProductCheckProvider;